webpackJsonp([85929988179075],{

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	var Pricing = function Pricing(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'columns' },
	    data.map(function (price) {
	      return _react2.default.createElement(
	        'div',
	        { key: price.plan, className: 'column', style: { border: '1px solid #eaecee' } },
	        _react2.default.createElement(
	          'section',
	          { className: 'section' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'has-text-centered has-text-weight-semibold' },
	            price.plan
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'is-size-1 has-text-weight-bold has-text-primary has-text-centered' },
	            '$',
	            price.price
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'has-text-weight-semibold' },
	            price.description
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            price.items.map(function (item) {
	              return _react2.default.createElement(
	                'li',
	                { key: item, className: 'is-size-5' },
	                item
	              );
	            })
	          )
	        )
	      );
	    })
	  );
	};
	
	Pricing.propTypes = {
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    plan: _propTypes2.default.string,
	    price: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    description: _propTypes2.default.string,
	    items: _propTypes2.default.array
	  }))
	};
	
	exports.default = Pricing;
	module.exports = exports['default'];

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pricingPageQuery = exports.PricingPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Pricing = __webpack_require__(142);
	
	var _Pricing2 = _interopRequireDefault(_Pricing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	var PricingPageTemplate = exports.PricingPageTemplate = function PricingPageTemplate(_ref) {
	  var title = _ref.title,
	      meta_title = _ref.meta_title,
	      meta_description = _ref.meta_description,
	      pricing = _ref.pricing;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        meta_title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: meta_description })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-primary is-bold' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-10 is-offset-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'section' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'title' },
	                  title
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'section section--gradient' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-10 is-offset-1' },
	              _react2.default.createElement(
	                'div',
	                { className: 'content' },
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'has-text-weight-semibold is-size-2' },
	                  pricing.heading
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'is-size-5' },
	                  pricing.description
	                ),
	                _react2.default.createElement(_Pricing2.default, { data: pricing.plans })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	PricingPageTemplate.propTypes = {
	  title: _propTypes2.default.string,
	  meta_title: _propTypes2.default.string,
	  meta_description: _propTypes2.default.string,
	  pricing: _propTypes2.default.shape({
	    heading: _propTypes2.default.string,
	    description: _propTypes2.default.string,
	    plans: _propTypes2.default.array
	  })
	};
	
	var PricingPage = function PricingPage(_ref2) {
	  var data = _ref2.data;
	  var frontmatter = data.markdownRemark.frontmatter;
	
	
	  return _react2.default.createElement(PricingPageTemplate, {
	    title: frontmatter.title,
	    meta_title: frontmatter.meta_title,
	    meta_description: frontmatter.meta_description,
	    pricing: frontmatter.pricing
	  });
	};
	
	PricingPage.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.shape({
	      frontmatter: _propTypes2.default.object
	    })
	  })
	};
	
	exports.default = PricingPage;
	var pricingPageQuery = exports.pricingPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-pricing-page-js-c763fa1f55611a00cc17.js